import $ from 'jquery';

export default function rankingSliderGroup() {
    const
        previous = $().isWelshPage() ? 'Blaenorol' : 'Previous',
        next     = $().isWelshPage() ? 'Nesaf' : 'Next',
        $slick    = $('.ranking-slider-group-js-slick'),
        $footnotes = $('.ranking-slider-group-footnote');

    function showOnlyFootnotesForActiveSlides() {
        $footnotes.hide();
        $slick.find('div.slick-active').each(function() {
            const
                $slide = $(this),
                index = parseInt($slide.attr('data-slick-index'));
            $footnotes.each(function() {
                const
                    $footnote = $(this),
                    slide = parseInt($footnote.attr('data-slide'));
                if (slide === index) {
                    $footnote.show();
                }
            });
        });
    }

    $slick.on('init afterChange', function() {
        showOnlyFootnotesForActiveSlides();
    }).slick({
        prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
        nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
        infinite: false,
        speed: 100,
        dots: true,
        variableHeight: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });
}
